import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "margin-b-standard" }
const _hoisted_2 = { class: "margin-b-standard" }
const _hoisted_3 = ["disabled"]

import { computed, onMounted, ref } from "vue";

import { useUIFilesStore } from "@/stores/ui-files.store";

import {
  OnlineFileToAttachToProduct,
  OnlineFileToAttachToSection
} from "@/models/api/files.model";

import { useFileManager } from "@/composables/files-manager";

import fileHelpers from "@/utils/file-helpers";

import ErrorMessage from "@/components/ErrorMessage.vue";
import Hint from "@/components/Hint.vue";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OnlineForm',
  setup(__props) {

const uiFilesStore = useUIFilesStore();
const { addOnlineAttachment } = useFileManager();

const fileName = ref<string>("");
const fileLocation = ref<string>("");
const isLocationInValid = ref<boolean>(false);
const isCurrentLocationInValid = computed<boolean>(() => {
  return (
    !fileHelpers.isAValidURL(fileLocation.value) &&
    !fileHelpers.isAValidPathToTheLocalFile(fileLocation.value)
  );
});
const validateFileLocation = (): void => {
  if (fileLocation.value.length > 0) {
    isLocationInValid.value = isCurrentLocationInValid.value;
  }
};
const resetLocationValidator = (): void => {
  isLocationInValid.value = false;
};

const attachNewFileToSection = (): void => {
  if (uiFilesStore.sectionToAttachFile) {
    const payload = {
      productId: uiFilesStore.sectionToAttachFile.product_id,
      name: fileName.value,
      location: fileLocation.value,
      section_id: uiFilesStore.sectionToAttachFile.id
    } as OnlineFileToAttachToSection;
    addOnlineAttachment(payload);
  }
};
const attachNewFileToProduct = (): void => {
  if (uiFilesStore.productToAttachFile) {
    addOnlineAttachment({
      productId: uiFilesStore.productToAttachFile.id,
      product_id: uiFilesStore.productToAttachFile.id,
      name: fileName.value,
      location: fileLocation.value,
      attachment_type: uiFilesStore.fileAttachmentType
    } as OnlineFileToAttachToProduct);
  }
};
const attachNewFile = (): void => {
  if (isLocationInValid.value) {
    return;
  }
  if (uiFilesStore.sectionToAttachFile) {
    attachNewFileToSection();
  } else {
    attachNewFileToProduct();
  }
  uiFilesStore.closeAttachFileModal();
};

const onLocationBlur = (): void => {
  if (!fileName.value && !isCurrentLocationInValid.value) {
    fileName.value = fileHelpers.getFileNameFromURL(fileLocation.value);
  }
  validateFileLocation();
};
const disableButton = computed<boolean>(() => {
  return (
    !fileName.value || !fileLocation.value || isCurrentLocationInValid.value
  );
});

const firstLocationInput = ref<HTMLInputElement | null>(null);
onMounted(() => {
  if (firstLocationInput.value) {
    firstLocationInput.value.focus();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(attachNewFile, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(RightSidebarTitle, { title: 'Link to online content:' }, {
        default: _withCtx(() => [
          _createVNode(Hint, {
            type: 'info',
            position: 'right'
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("p", null, "This could be a link to a sharepoint doc, or even a youtube video", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("input", {
        id: "file-location",
        ref_key: "firstLocationInput",
        ref: firstLocationInput,
        class: _normalizeClass({ error: isLocationInValid.value }),
        onFocus: resetLocationValidator,
        onBlur: onLocationBlur,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileLocation).value = $event)),
        "data-testing": "attach-file-location"
      }, null, 34), [
        [_vModelText, fileLocation.value]
      ]),
      (isLocationInValid.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            message: 'Must be a valid address'
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RightSidebarTitle, { title: 'Name:' }, {
        default: _withCtx(() => [
          _createVNode(Hint, {
            type: 'info',
            position: 'right'
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("p", null, "Good naming makes it easier to find files/references later", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fileName).value = $event)),
        "data-testing": "attach-new-file-name"
      }, null, 512), [
        [_vModelText, fileName.value]
      ])
    ]),
    _createElementVNode("button", {
      "data-testing": "attach-file-btn",
      disabled: disableButton.value,
      class: "btn-1 full-width submit-btn"
    }, " Attach content ", 8, _hoisted_3)
  ], 32))
}
}

})